import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Menu, Icon, Row, Col, Select, Modal, Table, List, Card, Empty, Tooltip, Button } from 'antd';
import { getIndexData, getNoticeList, getCountIndexData, getComboxList_box, getStEqUseTimeTop, getStUserCreditInfo, updateBaseUser } from '@/api/api';
import servers from '@/api/server';
import echarts from 'echarts';
import { Scrollbars } from 'react-custom-scrollbars';
import styles from './homePage.module.css';
import './index.css'
import ConsumableCost from '@/components/consumableCost'
import ProjectSynthesis from '@/components/projectSynthesis'
import ProjectTasks from '@/components/projectTasks'
import ResearchGoup from '@/components/ResearchGoup'
import StaffCredit from '@/components/StaffCredit'
import Consumables from '@/components/Consumables'
import Equipment from '@/components/Equipment'
import WeekAttendance from '@/components/WeekAttendance'
import MonthlyAttendance from '@/components/MonthlyAttendance'
import WorkList from '@/components/workList'

import Polyline from '@/components/Polyline'
import CircleBook from '@/components/CircleBook'
import { tuple } from 'antd/lib/_util/type';
import { object } from 'prop-types';
import workList from '../workList';

const SubMenu = Menu.SubMenu;
const Option = Select.Option;

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newTime: '早上好',
      nickName: '',
      customUrl: '',
      setFlag: null,
      visibleleft: false,//对话框弹出
      visibleright: false,//对话框弹出(you)
      homePageFlagLeft: 0,
      homePageFlagRight: 0,
      left: 0,
      right: 1,
      homePageList: [
        { id: 1, projectNmae: '试剂耗材成本占比' },
        { id: 11, projectNmae: "人员设备使用时长和次数统计" },
        { id: 3, projectNmae: "课题组设备使用时长和次数统计" },
        { id: 4, projectNmae: "人员信用统计" },
        { id: 5, projectNmae: "经费统计占比" },
        { id: 6, projectNmae: "实验室总使用经费" },
        { id: 7, projectNmae: "课题项目过期率" },
        { id: 8, projectNmae: "月耗材成本趋势" },
        { id: 10, projectNmae: "周出勤率" },
        { id: 2, projectNmae: "项目综合统计图" },
        { id: 12, projectNmae: "工作清单" }],
      homePageList1: [
        { id: 1, projectNmae: '试剂耗材成本占比' },
        { id: 11, projectNmae: "人员设备使用时长和次数统计" },
        { id: 3, projectNmae: "课题组设备使用时长和次数统计" },
        { id: 4, projectNmae: "人员信用统计" },
        { id: 5, projectNmae: "经费统计占比" },
        { id: 6, projectNmae: "实验室总使用经费" },
        { id: 7, projectNmae: "课题项目过期率" },
        { id: 8, projectNmae: "月耗材成本趋势" },
        { id: 10, projectNmae: "周出勤率" },
        { id: 2, projectNmae: "项目综合统计图" },
        { id: 12, projectNmae: "工作清单" }
      ],
      runNum: 0,
      audiNum: 0,
      reqNum: 0,
      jobList: [],
      wUsereq_pagination: {
        pageSize: 5,
        hideOnSinglePage: true,
      },
      wUsereq_loading: false,
      wUsereqList: [],
      wlist: [{
        list: [],
        title: '课题组内信用',
      }],
      userCreditTop: [{
        list: [],
        title: '最高信用分',
      }, {
        list: [],
        title: '最低信用分',
      }],
      noticeList: []
    }
    this.materialTimeChange = this.materialTimeChange.bind(this);
    this.getData = this.getData.bind(this);
    this.showNotice = this.showNotice.bind(this);
    this.getStEqUseTimeTop = this.getStEqUseTimeTop.bind(this);
    this.setValue = this.setValue.bind(this);
    this.getUserCreditInfo = this.getUserCreditInfo.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.getData()
    this.getStEqUseTimeTop();
    this.getUserCreditInfo();
    // this.materialTimeChange()

  }
  componentDidMount() {
    // let script = document.createElement('script');
    // script.type = 'text/javascript';
    // script.src = "https://apip.weatherdt.com/float/static/js/r.js?v=1111";
    // document.getElementById('append').appendChild(script);
    const that = this;
    this.getData();
    this.getStEqUseTimeTop();
    this.getUserCreditInfo();
    // this.materialTimeChange();
    console.log(JSON.parse(localStorage.getItem('user')))
    let num = new Date().getHours()
    if (num > 6 && num <= 12) {
      this.setState({
        newTime: '上午好'
      })
    } else if (num > 12 && num <= 18) {
      this.setState({
        newTime: '下午好'
      })
    } else if (num > 18 && num < 24) {
      this.setState({
        newTime: '晚上好'
      })
    }
    this.setState({
      nickName: JSON.parse(localStorage.getItem('user')).nickName,
      setFlag: JSON.parse(localStorage.getItem('user')).setFlag,
      homePageFlagLeft: JSON.parse(localStorage.getItem('user')).userObj.customUrl.split(',')[0] - 0,
      // homePageFlagRight:0
      homePageFlagRight: JSON.parse(localStorage.getItem('user')).userObj.customUrl ? JSON.parse(localStorage.getItem('user')).userObj.customUrl.split(',')[1] - 0 : 0
    })
  }
  //首页自定义修改
  getUpdata = () => {
    let params = { customUrl: this.state.customUrl }
    updateBaseUser(params, res => {
      console.log(res)
      let value = JSON.parse(localStorage.getItem('user'))
      value.userObj.customUrl = this.state.customUrl
      localStorage.setItem('user', JSON.stringify(value))
    })
  }
  //右边选择
  handleRight = (value) => {
    console.log(value)
    this.setState({
      // right: value
      homePageFlagRight: value,
      customUrl: [this.state.homePageFlagLeft, value].join(),
    }, () => {
      this.getUpdata()
    })
  }
  //左边选择
  handleLeft = (value) => {
    console.log(value)
    this.setState({
      // left: value
      homePageFlagLeft: value,
      customUrl: [value, this.state.homePageFlagRight].join(),
    }, () => {
      this.getUpdata()
    })
  }
  getStEqUseTimeTop() {
    const that = this;
    let params = { flag: '1' };
    getStEqUseTimeTop(params, res => {
      console.log(res);
      if (res.statusCode === 1000) {

        // that.setValue('nUsereqList',res.nList ? res.nList : [])
        that.setValue('wUsereqList', res.nList ? res.nList : [])
        // that.setValue('eqTimestr',res.countNum)
      }
    }, err => {
      console.log(err)
    })
  }

  // 人员信用情况情况
  getUserCreditInfo() {
    const that = this;
    let userCreditTop = this.state.userCreditTop;
    getStUserCreditInfo({}, res => {
      console.log(res);
      if (res.statusCode === 1000) {
        userCreditTop[0].list = res.hcreditList ? res.hcreditList : [];
        userCreditTop[1].list = res.lcreditList ? res.lcreditList : [];
        that.setValue('userCreditTop', userCreditTop)
      }
    }, err => {
      console.log(err)
    })
  }

  setValue(feild, value) {
    this.setState({
      [feild]: value
    })
    // console.log(this.state.pageNo);
    // console.log(this.state.getNum);
  }
  getData() {
    const that = this;
    // 获取首页数据
    getIndexData({}, res => {
      if (res.statusCode !== 1000) {
        return
      };
      that.setState({
        runNum: res.runNum,
        unFinished: res.unFinished,
        audiNum: res.audiNum,
        reqNum: res.reqNum,
        jobList: res.jobList ? res.jobList : []
      })
    }, err => {
      console.log(err)
    });

    // 获取首页公告列表
    let params = {
      page: 1,
      // rows: 5,
    };
    getNoticeList(params, res => {
      console.log(res)
      that.setState({
        noticeList: res.rows,
      })
    }, err => {
      console.log(err)
    })
  }

  // 公告内容弹窗
  showNotice(notice) {
    Modal.info({
      title: notice.title,
      content: (
        <div>
          <p>{notice.noticeContent}</p>
        </div>
      ),
      okText: '确定',
      onOk() { },
    });
  }

  materialTimeChange = (value) => {
    const that = this;
    let params = {
      type: value ? parseInt(value) : 1
    };
    getCountIndexData(params, res => {
      if (res.statusCode !== 1000 && !res.reaNames) {
        return
      }
      const materialChart = echarts.init(document.getElementById('material_echarts'));
      let lostNums = [], usedNums = [], lost = [], used = [], reaNames = [], reaNamesArr = res.reaNames;
      res.lostNums && res.lostNums.map(x => {
        lostNums.push((parseFloat(x) * 100).toFixed(1))
      });
      res.usedNums && res.usedNums.map(x => {
        usedNums.push((parseFloat(x) * 100).toFixed(1))
      });
      res.used && res.used.map(x => {
        used.push(parseInt(x))
      });
      res.lost && res.lost.map(x => {
        lost.push(parseInt(x))
      });
      res.reaNames.map(x => {
        reaNames.push(x.substr(0, 5))
        // if(x.length > 6){
        // }else{
        //   reaNames.push(x)
        // }
      });
      materialChart.setOption({
        title: {
          // subtext: '耗材使用量排名前五'
        },
        legend: {
          data: ['剩余库存占比(数量)', '已使用占比(数量)'],
          bottom: 0,
          right: 0
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (datas) {
            var res = reaNamesArr[datas[0].dataIndex] + '<br>', val;
            var tip = '';
            for (var i = 0, length = datas.length; i < length; i++) {
              val = (datas[i].value) + '%';
              if (datas[i].seriesIndex === 0) {
                res += '<span style="width:8px;height:8px;display:inline-block;border-radius:50%;background:#c23531;margin-right:5px"></span>';
                tip = lost[datas[i].dataIndex]
              };
              if (datas[i].seriesIndex === 1) {
                res += '<span style="width:8px;height:8px;display:inline-block;border-radius:50%;background:#2f4554;margin-right:5px"></span>';
                tip = used[datas[i].dataIndex]
              };
              res += datas[i].seriesName + '：' + val + '(' + tip + ')<br/>'
            }
            return res;
          }
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            data: reaNames
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '剩余库存占比(数量)',
            type: 'bar',
            data: lostNums,
            stack: '总量',
            label: {
              normal: {
                show: true,
                position: 'insideTop',
                formatter: (params) => {
                  return params.data + '%'
                }
              }
            },
            itemStyle: {
              // color:'#32c5d2'
            },
            barWidth: 36
          },
          {
            name: '已使用占比(数量)',
            type: 'bar',
            data: usedNums,
            stack: '总量',
            label: {
              normal: {
                show: true,
                position: 'insideBottom',
                formatter: (params) => {
                  return params.data + '%'
                }
              }
            },
            barWidth: 36
          }
        ]
      })
    }, err => {
      console.log(err)
    })

  }
  handleOk = () => {
    this.setState({
      visibleleft: false,
    })
  }
  handleCancel = () => {
    console.log(2)
    this.setState({
      visibleleft: false
    })
  }
  showModal = () => {
    this.setState({
      visibleleft: true
    })
  }
  handleOk1 = () => {
    this.setState({
      visibleright: false,
    })
  }
  handleCancel1 = () => {
    console.log(2)
    this.setState({
      visibleright: false
    })
  }
  showModal1 = () => {
    this.setState({
      visibleright: true
    })
  }
  render() {
    const that = this;
    const { setFlag, runNum, audiNum, reqNum, unFinished, jobList, noticeList, wUsereqList, wUsereq_loading, wUsereq_pagination, userCreditTop, wlist, homePageList, homePageList1, homePageFlagLeft, homePageFlagRight } = this.state;
    const wUsereq_columns = [
      {
        title: '姓名',
        dataIndex: 'userName',
        align: 'center',
        width: '19%',
        onCell: () => {
          return {
            style: {
              maxWidth: 30,
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              cursor: 'pointer'
            }
          }
        },
        render: (text, record) => {
          return (
            <Tooltip placement="topLeft" title={text}>{text}</Tooltip>
          )
        }
      }, {
        title: '设备预约时长',
        dataIndex: 'userNum',
        align: 'center',
        sorter: (a, b) => a.userNum - b.userNum
      }, {
        title: '设备预约次数',
        dataIndex: 'useNum',
        align: 'center',
        sorter: (a, b) => a.useNum - b.useNum
      }, {
        title: '信用分',
        dataIndex: 'creditValue',
        align: 'center',
        sorter: (a, b) => a.creditValue - b.creditValue
      }
    ]
    return (
      <div className={styles.home}>
        {/* <div>
          <iframe name="weather_inc" src="http://i.tianqi.com/index.php?c=code&id=1" width="330" height="35" frameBorder="0" marginWidth="0" marginHeight="0" scrolling="no" src="http://i.tianqi.com/index.php?c=code&id=1" security="restricted" sandbox=""></iframe>
        </div> */}
        <Row style={{
          marginBottom: screen.width === 1440 ? '8px' : '30px',
          marginTop: screen.width === 1440 ? '2px' : '10px',
          borderRadius: '5px'
        }} type="flex" justify="space-between" className='row1'>
          <Col span={15}>
            <h1 style={{ color: "#fff", fontSize: '26px', marginTop: '-10px' }}>{this.state.newTime},{this.state.nickName}</h1>
            <div style={{ height: "26px", borderRadius: '4px' }}>
              {/* <iframe name="Weather" src="http://www.39ol.com/Plugin-2-101010100.html" width="200" height="20" marginwidth="0" marginheight="0" hspace="0" vspace="0" frameborder="0" scrolling="no"></iframe> */}
              {/* <iframe name="weather_inc" src="http://i.tianqi.com/index.php?c=code&id=1" width="580" height="35" frameBorder="0" marginWidth="0" marginHeight="0" scrolling="no" security="restricted" sandbox=""></iframe> */}
              <iframe scrolling="no" src="https://tianqiapi.com/api.php?style=tf&skin=pitaya" frameborder="0" width="400" height="24" allowtransparency="true"></iframe>
            </div>
            <Row type="flex" justify="space-between">
              <Col span={7}>
                <Link to={{ pathname: "/userCenter", query: { key: '2' } }}>
                  <span className='myspan'><i className="iconfont icon-daishenpi"></i></span>
                  <div className='rightDiv'>
                    <div className='div1'>待审批</div>
                    <div className='div2' style={{ color: '#f6facc' }}>{audiNum}</div>
                  </div>

                </Link>
              </Col>
              <Col span={7}>
                <Link to={{ pathname: "/userCenter", query: { key: '8' } }}>
                  {/* <span>我的申请</span><br />
                  <b>{reqNum}</b>
                  <i className="iconfont icon-anquanjianbaotongzhiguanli"></i> */}
                  <span className='myspan'><i className="iconfont icon-xiangmu"></i></span>
                  <div className='rightDiv'>
                    <div className='div1'>待完成</div>
                    <div className='div2'>{unFinished}</div>
                  </div>
                </Link>
              </Col>
              <Col span={7}>
                <Link to={{ pathname: "/userCenter", query: { key: '1' } }}>
                  {/* <span>待审批</span><br />
                  <b>{audiNum}</b>
                  <i className="iconfont icon-tubiaolunkuo_huaban"></i> */}
                  <span className='myspan'><i className="iconfont icon-application-for-membership"></i></span>
                  <div className='rightDiv'>
                    <div className='div1'>我的申请</div>
                    <div className='div2'>{reqNum}</div>
                  </div>
                </Link>
              </Col>
            </Row>
          </Col>
          <Col span={8} className={styles.home_notice}>
            <h2 style={{ marginTop: '-4px' }}><i className="iconfont icon-notice c_orange" ></i>公告</h2>
            {noticeList.length < 1 &&
              <img src={servers.defaultMsg} className="defaultImg1" style={{ top: '56%' }} />
            }
            {noticeList.length > 0 &&
              <Scrollbars className='myScroll treeScroll' style={{ height: '130px' }}>
                <ul>
                  {noticeList.map(x => {
                    return (
                      <li key={x.id}><a href="javascript:" onClick={() => that.showNotice(x)}>{x.title}</a></li>
                    )
                  })}

                </ul>
              </Scrollbars>

            }
          </Col>
        </Row>
        <Row className={styles.home_con_modules} type="flex" justify="space-between">
          <Modal
            style={{ width: '600px' }}
            title="请选择您所想要展示的模块"
            visible={this.state.visibleleft}
            height='100px'
            onOk={this.handleOk}
            onCancel={this.handleCancel}
          >
            <span>
              <span style={{ marginRight: '5px' }}> 选择切换模块 :</span>
              <Select
                style={{ width: '130px' }}
                // value={timeType}
                placeholder="请选择"
                onChange={this.handleLeft}
                // onSelect={this.storePickTypeSelect}
                className="inlineBlock mr10"
              >
                {homePageList.map(x => {
                  return (
                    <Option value={x.id.toString()} key={x.id} title={x.projectNmae}>
                      {x.projectNmae}
                    </Option>
                  )
                })}
              </Select></span>
          </Modal>
          <Modal
            // style={{ width: '600px' }}
            title="请选择您所想要展示的模块"
            visible={this.state.visibleright}
            // height='100px'
            onOk={this.handleOk1}
            onCancel={this.handleCancel1}
          >
            <span>
              <span style={{ marginRight: '5px' }}> 选择切换模块 :</span>
              <Select
                style={{ width: '130px' }}
                // value={timeType}
                placeholder="请选择"
                onChange={this.handleRight}
                // onSelect={this.storePickTypeSelect}
                className="inlineBlock mr10"
              >
                {homePageList1.map(x => {
                  return (
                    <Option value={x.id.toString()} key={x.id} title={x.projectNmae}>
                      {x.projectNmae}
                    </Option>
                  )
                })}
              </Select>
            </span>
          </Modal>
          <Col span={11} className={styles.home_task} style={{ position: 'relative' }}>
            <WorkList />
          </Col>

          <Col span={12} className={styles.home_material} style={{ position: 'relative' }}  >
            {setFlag == 1 && <img src='../images/Button.png' className="iconfont icon-xitong" onClick={this.showModal1} style={{ position: 'absolute', right: '7px', width: '13px', top: '4px', zIndex: '100', cursor: 'pointer' }} />}
            {/* {this.change(homePageFlagRight)} */}
            {homePageFlagRight == 0 && <span>
              <div className='tc' style={{ padding: "40px" }}>
                <img src={servers.defaultNoContentPath} alt="暂无内容" className="noContent" />
              </div>
            </span>}
            {homePageFlagRight == 1 && <ConsumableCost />}
            {/* {homePageFlagRight == 2 && <ProjectSynthesis />} */}
            {homePageFlagRight == 3 && <ResearchGoup />}
            {homePageFlagRight == 4 && <StaffCredit />}
            {homePageFlagRight == 5 && <CircleBook />}
            {homePageFlagRight == 6 && <Polyline />}
            {homePageFlagRight == 7 && <ProjectTasks />}
            {homePageFlagRight == 8 && <Consumables />}
            {homePageFlagRight == 11 && <Equipment />}
            {homePageFlagRight == 9 && <MonthlyAttendance />}
            {homePageFlagRight == 10 && <WeekAttendance />}
            {homePageFlagRight == 2 && <ProjectSynthesis />}
          </Col>
        </Row>

      </div >
    );
  }
}

export default HomePage;